// Cart drawer rendering. Kept as a Liquid JS asset so translations and money formats stay Shopify-driven.
var headerCartRoutes = {
    cart: "\/cart",
    checkout: '/checkout'
};

function formatHeaderCartMoney(cents) {
    return Shopify.formatMoney(Math.max(0, Math.round(parseFloat(cents) || 0)), "");
}

function getHeaderCartTotal(cart) {
    if (cart && cart.total_price !== undefined && cart.total_price !== null) {
        return Math.max(0, Math.round(parseFloat(cart.total_price) || 0));
    }

    var total = 0;

    if (cart && cart.items) {
        jQuery.each(cart.items, function(i, item) {
            total += Math.max(0, Math.round(parseFloat(item.final_line_price || item.line_price || 0) || 0));
        });
    }

    return total;
}

function renderHeaderCartTotals(cart) {
    var total = getHeaderCartTotal(cart);
    var money = formatHeaderCartMoney(total);

    $('.ajax-total').attr('data-cart-cents', total).html(money);
    $('#cart-info .cart-item-total-price').attr('data-cart-cents', total).html(money);
    $('.addcart-modal-subtotal').html('<strong>Total Price:</strong>' + money);
}

function renderHeaderCartCount(cart) {
    var count = cart && cart.item_count !== undefined ? parseInt(cart.item_count, 10) : 0;
    var $count = $('.cart-target .cart-icon .numberr, .cart-target .cart-icon .number').first();

    if (isNaN(count)) {
        count = 0;
    }

    if (!$count.length) {
        $('.cart-target .cart-icon').html('<span class="numberr"></span>');
        $count = $('.cart-target .cart-icon .numberr').first();
    }

    $count.removeClass('number main-color').addClass('numberr').text(count);
}

function shouldShowHeaderCartSku() {
    var setting = $('.cart-target[data-show-cart-dropdown-sku]').first().attr('data-show-cart-dropdown-sku');

    if (setting === undefined) {
        return true;
    }

    return setting === true || setting === 'true';
}

function getHeaderCartImageUrl(image, size) {
    var fallbackImage = "\/\/auscaterquip.com.au\/cdn\/shop\/t\/2\/assets\/default-image.jpg?v=34021875706906074901779359004";

    if (!image) {
        return fallbackImage;
    }

    if (typeof Shopify !== 'undefined' && typeof Shopify.resizeImage === 'function') {
        return Shopify.resizeImage(image, size) || fallbackImage;
    }

    if (typeof Shopify !== 'undefined' && Shopify.Image && typeof Shopify.Image.getSizedImageUrl === 'function') {
        return Shopify.Image.getSizedImageUrl(image, size) || fallbackImage;
    }

    return image;
}

Shopify.updateCartInfo = function(cart, cart_summary_id, cart_count_id) {
    if ((typeof cart_summary_id) === 'string') {
        var cart_summary = jQuery(cart_summary_id);
        if (cart_summary.length) {

            cart_summary.empty();

            jQuery.each(cart, function(key, value) {
                if (key === 'items') {
                    if (value.length) {
                        jQuery('<div class="items"></div>').appendTo(cart_summary);
                        var table = jQuery(cart_summary_id + ' div.items');

                        jQuery.each(value, function(i, item) {
                            var itemUrl = item.url || '#';
                            var itemImage = getHeaderCartImageUrl(item.image, 'small');
                            var $item = jQuery('<div/>', {
                                'class': 'items-inner'
                            });
                            var $imageLink = jQuery('<a/>', {
                                href: itemUrl
                            });
                            var $itemInfo = jQuery('<div/>', {
                                'class': 'cart-item-info'
                            });
                            var $titleLink = jQuery('<a/>', {
                                href: itemUrl
                            });

                            jQuery('<img alt="" width="160" height="160" />')
                                .attr('src', itemImage)
                                .appendTo($imageLink);

                            jQuery('<div/>', {
                                'class': 'cart-item-image'
                            }).append($imageLink).appendTo($item);

                            $titleLink
                                .append(document.createTextNode(item.quantity || 0))
                                .append(jQuery('<span/>', {
                                    'class': 'x',
                                    text: ' x '
                                }))
                                .append(document.createTextNode(item.title || ''));

                            jQuery('<div/>', {
                                'class': 'cart-item-title'
                            }).append($titleLink).appendTo($itemInfo);

                            if (shouldShowHeaderCartSku() && item.sku) {
                                jQuery('<div/>', {
                                    'class': 'cart-item-sku',
                                    text: 'SKU: ' + item.sku
                                }).appendTo($itemInfo);
                            }

                            jQuery('<div/>', {
                                'class': 'cart-item-price',
                                html: formatHeaderCartMoney(item.price)
                            }).appendTo($itemInfo);

                            $itemInfo.appendTo($item);

                            jQuery('<a/>', {
                                'class': 'cart-close',
                                href: '#',
                                'data-cart-remove': i + 1
                            }).append(jQuery('<i/>', {
                                'class': 'fa fa-close',
                                title: "Remove"
                            })).appendTo($item);

                            $item.appendTo(table);
                        });

                        jQuery('<div class="subtotal"><span>Total</span><span class="cart-item-total-price"></span></div>').appendTo(cart_summary);
                        jQuery('<div class="action"><a href="' + headerCartRoutes.cart + '" class="cart-action-button cart-action-view">View Cart</a><br /><a class="cart-action-button cart-action-checkout" href="' + headerCartRoutes.checkout + '">Checkout</a></div>').appendTo(cart_summary);
                    } else {
                        jQuery('<div class="cart-item-empty text-center"><p>Your shopping cart is empty.</p></div>').appendTo(cart_summary);
                    }
                }
            });
        }
    }

    updateCartDesc(cart);
};

function updateCartDesc(data){
    renderHeaderCartCount(data);
    renderHeaderCartTotals(data);
}

Shopify.onCartUpdate = function(cart) {
    Shopify.getCart(function(freshCart) {
        Shopify.updateCartInfo(freshCart, '#cart-info #cart-content', 'shopping-cart');
    });
};

$(window).load(function() {
    Shopify.getCart(function(cart) {
        Shopify.updateCartInfo(cart, '#cart-info #cart-content');
    });
});
